import { render } from "./BrandFounderCard.vue?vue&type=template&id=afecd968&scoped=true"
import script from "./BrandFounderCard.vue?vue&type=script&lang=js"
export * from "./BrandFounderCard.vue?vue&type=script&lang=js"

import "./BrandFounderCard.vue?vue&type=style&index=0&id=afecd968&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afecd968"]])

export default __exports__